import Identity from "../components/Identity/Staff/Default";
import Profiles from "../components/Identity/Staff/Profiles";
import PrintFolder from "../components/Identity/Staff/PrintFolder";
import Latest from "../components/Identity/Staff/Latest";
import CreateSingle from "../components/Identity/Staff/CreateSingle";
import CreateBulk from "../components/Identity/Staff/CreateBulk";
// import Statistics from "../components/Identity/Staff/Statistics";

const routes = [
  {
    path: "/identity/staff",
    component: Identity,
    redirect: "/identity/staff/latest",
    meta: {
      requiresAuth: true,
      description: "Identity creation and management",
    },
    children: [
      // {
      //   path: "",
      //   name: "identity.staff",
      //   component: Statistics,
      // },
      {
        path: "latest",
        name: "identity.staff.latest",
        component: Latest,
      },
      {
        path: "profiles",
        name: "identity.staff.profiles",
        component: Profiles,
      },
      {
        path: "print",
        name: "identity.staff.print",
        component: PrintFolder,
      },
      {
        path: "create-single",
        name: "identity.staff.create_single",
        component: CreateSingle,
      },
      {
        path: "create-bulk",
        name: "identity.staff.create_bulk",
        component: CreateBulk,
      },
    ],
  },
];

export default routes;
